import { WebsiteRoute } from 'dew-types'
import { compile, match } from 'path-to-regexp'

import { MatchedRoute, UrlParams } from './types'

export function matchRoutes(path: string, routes: WebsiteRoute[]) {
  const result: MatchedRoute[] = []
  let iter = [...routes]
  let prefix = ''
  while (iter.length > 0) {
    const [current, ...nextIter] = iter
    const hasChildren = !!current?.children?.length
    let pattern = prefix + current.pattern
    if (hasChildren) {
      pattern = pattern + '/:others*'
    }
    if (pattern !== '/' && pattern.endsWith('/')) {
      pattern = pattern.substring(0, pattern.length - 1)
    }
    const matcher = match<UrlParams>(pattern, { decode: decodeURIComponent })
    const matchResult = matcher(path)
    if (matchResult) {
      prefix = prefix + current.pattern
      iter = hasChildren ? [...(current.children || [])] : []
      result.push({
        name: current.name,
        page: current.page,
        pattern: current.pattern,
        lang: current.lang,
        path,
        params: matchResult.params,
        matcher,
        pathFn: compile(pattern),
      })
    } else {
      iter = nextIter
    }
  }
  return result
}
